<template>
  <b-modal centered ref="modal" :ok-only="true">
    <template slot="modal-title">
      Błąd
    </template>
    <div v-if="errorMsg">
      {{ errorMsg }}
    </div>
    <div v-else>
      Wystąpił problem z połączeniem. Spróbuj ponownie później, jeżeli błąd będzie się powtarzał <a href="https://pit.uke.gov.pl/pl-pl/formularz-kontaktowy/" target="_blank">skontaktuj</a> się z administratorem systemu.
    </div>
    <template slot="modal-ok">
      Zamknij
    </template>
  </b-modal>
</template>


<script>
  export default {
    name: "ErrorModal",
    data() {
      return {
        errorMsg: null
      }
    },
    methods: {
      show(err) {
        if(err) {
          this.errorMsg = err.body.error;
        }

        this.$refs.modal.show();
      }
    }
  }

</script>
